import styles from "./change-password-success.module.css";
import { useNavigate } from "react-router";
import { useTranslation } from "react-i18next";
import Success from "illustrations/success.png";

const ChangePasswordSuccess = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <div className={styles.wrapper}>
      <div className={styles.container}>
        <section className={styles["illustration-container"]}>
          <img src={Success} alt="" className={styles["illustration"]} />
        </section>
        <section className={styles.content}>
          <h1 className="title-1">
            {t("forgot-password.reset-password.success")}
          </h1>
          <p className="subtitle-1-variant">
            {t("forgot-password.reset-password.success-description")}
          </p>
        </section>
        <button className="btn btn--primary" onClick={() => navigate("/login")}>
          {t("actions.sign-in")}
        </button>
      </div>
    </div>
  );
};

export default ChangePasswordSuccess;
